import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { PersonalCabinet } from './PersonalCabinet.types';

export function usePersonalCabinetData(): Page<PersonalCabinet>['templateFields'] {
  return useCurrentPage<Page<PersonalCabinet>>().templateFields;
}
